var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditRect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1107 15.8945C13.882 16.1354 13.6035 16.3171 13.2971 16.4253L10.3532 17.4611C10.141 17.5359 9.9187 17.574 9.69497 17.5739C9.1389 17.5739 8.61614 17.3454 8.22299 16.9303C7.66183 16.3378 7.46921 15.4763 7.72016 14.6817L8.70148 11.5744C8.80398 11.251 8.97609 10.957 9.20431 10.7155L15.5627 4.00392H3.12233C1.71945 4.00392 0.578125 5.20865 0.578125 6.68946V22.3145C0.578125 23.7953 1.71945 25 3.12233 25H17.925C19.3278 25 20.4692 23.7953 20.4692 22.3145V9.18292L14.1107 15.8945Z",
    fill: "#0E7AFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1856 11.7514C10.1095 11.8318 10.0521 11.9298 10.018 12.0377L9.03672 15.145C8.99598 15.2741 8.99008 15.4125 9.01969 15.5449C9.0493 15.6773 9.11324 15.7983 9.20436 15.8945C9.29547 15.9907 9.41015 16.0582 9.53555 16.0894C9.66096 16.1207 9.79213 16.1144 9.91437 16.0714L12.8582 15.0356C12.9604 14.9997 13.0533 14.9392 13.1295 14.8587L21.7975 5.70919L18.8537 2.60182L10.1856 11.7514ZM22.6152 0.357532C22.1636 -0.119177 21.4314 -0.119177 20.9798 0.357532L19.8349 1.56598L22.7788 4.6734L23.9236 3.46495C24.3752 2.98824 24.3752 2.21534 23.9236 1.73863L22.6152 0.357532Z",
    fill: "#0E7AFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_1687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6842,
    height: 25,
    fill: "white",
    transform: "translate(0.578125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRect);
export default __webpack_public_path__ + "static/media/edit-rect.46bfb3b5535b7a1fc38e5d0fbaf911a3.svg";
export { ForwardRef as ReactComponent };